import type { JSX } from 'preact';
import styles from './ThumbnailImage.module.scss';

export type ThumbnailImageProps = JSX.HTMLAttributes<HTMLImageElement> & {
  src: string;
  width: number;
  height: number;
  alt?: string;
  loading?: 'lazy' | 'eager';
};
export default function ThumbnailImage({
  src,
  alt = '',
  width,
  height,
  loading = 'lazy',
  ...props
}: ThumbnailImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      class={styles.thumbImage}
      loading={loading}
      decoding="async"
      {...props}
    />
  );
}
